import React from 'react';
import Hero from './Hero';
import Team from './Team';

function AboutSection() {
    return ( 
        <>
        
        <Hero/>
        <Team/>
        
        </>
     );
}

export default AboutSection;